
(() => {
  const LIVE = true;

  /* ---------- Settings you can edit ---------- */
  // On rarely.co, photos load from Shopify Files (Content → Files). Upload them with these exact names.
  const IMAGE_BASE = LIVE ? '/cdn/shop/files/' : 'img/';
  // Free-shipping threshold in dollars. 0 hides the progress line. Only set this if checkout really offers it.
  const FREE_SHIP_AT = 0;
  // Multi-truck offer, shown in the fleet builder. Example: { min: 2, percent: 10 }. Set up the matching
  // automatic discount in Shopify first, then fill this in. null hides it.
  const MULTI_BUY = null;
  // Optional strip under the header, e.g. 'Order by Dec 12 for Christmas delivery'. '' hides it.
  const HOLIDAY_NOTE = '';

  const P = {
    loader:  { name: 'Wheel Loader',    handle: 'wheel-loader', price: 195, variant: 44562014634083, img: 'VFA1047-1.jpg?v=1788629234',
               does: 'Steers, and the bucket raises and lowers on wooden joints. No metal hardware.', specs: ['15.7 in long', 'Ages 3+', '2 removable figures'] },
    dumper:  { name: 'Wheels Dumper',   handle: 'wheels-dumper-steerable-wooden-toy-dump-truck-with-tippable-bed', price: 155, variant: 44452349345891, img: 'VFA1083-1.jpg?v=1786036466',
               does: 'Steers, and the bed tips to dump the load. Interlocked, doweled and glued.', specs: ['2 figures', 'Hitches to the trailer'] },
    trailer: { name: 'Dumper Trailer',  handle: 'dumper-trailer', price: 99, variant: 44562014011491, img: 'VFA1046-1.jpg?v=1788629092',
               does: 'A second tipping load that hitches behind the dumper. Wooden axles.', specs: ['13 in long', 'Ages 3+', 'Add-on'] },
    fire:    { name: 'Fire Engine',     handle: 'fire-engine', price: 205, variant: 44562014240867, img: 'VFA1048-1.jpg?v=1788629134', badge: 'Biggest crew',
               does: 'Steers, and the three-section ladder rotates, raises and reaches about 26 inches. Wooden axles, six firefighters.', specs: ['15.25 in long', 'Ages 3+', '6 firefighters'] },
    trans:   { name: 'Car Transporter', handle: 'car-transporter', price: 195, variant: 44562013880419, img: 'VFA1049-1.jpg?v=1788629060',
               does: 'The top deck folds into a ramp, and a knob on the cab steers. A Speedy car comes with it.', specs: ['20.25 in long', 'Ages 3+', 'Speedy car + 2 figures'] },
    jeep:    { name: 'Wooden Jeep',     handle: 'wooden-jeep-toy-steerable-2-figures-fagus-11', price: 135, variant: 44452124098659, img: 'VFA1075-1.jpg?v=1786024515',
               does: 'Steers, with two figures along for the ride. Hitches to the Dumper Trailer.', specs: ['11 in long', 'Ages 3+', '2 figures'] },
    unimog:  { name: 'Unimog Truck',    handle: 'unimog-wooden-truck-steerable-9-8-2-figures-included', price: 115, variant: 44452124196963, img: 'VFA1002-1.jpg?v=1786024591', badge: 'From 24 months',
               does: 'The youngest pick. Steers like the big trucks and takes add-ons like the Dumper Trailer.', specs: ['9.8 in long', 'From 24 months', '2 figures'] },
    speedy:  { name: 'Speedy Car',      handle: 'speedy-car', price: 38, variant: 44562014306403, img: 'VFA1101-1.jpg?v=1788629167', available: false,
               does: 'Hand-sized, with sturdy rubber tires that roll beautifully.', specs: ['5.5 in long', 'Ages 3+'] },
    van:     { name: 'Van',             handle: 'van', price: 38, variant: 44562014371939, img: 'VFA1102-1.jpg?v=1788629199', available: false,
               does: 'Smooth, solid and easy to grab.', specs: ['5 in long', 'Ages 3+'] }
  };
  const TRUCKS = ['loader', 'dumper', 'fire', 'trans', 'jeep', 'unimog', 'speedy', 'van'];
  // What to suggest right after something lands in the bag.
  const XSELL = { dumper: 'trailer', trailer: 'dumper', jeep: 'trailer', unimog: null, loader: 'dumper', fire: 'loader', trans: 'jeep', speedy: 'trans', van: 'unimog' };
  const XSELL_WHY = {
    trailer: 'Hitches on for a second tipping load.',
    dumper: 'The truck the trailer was made to follow.',
    loader: 'Loads the dumper while the crew stands by.',
    jeep: 'Same scale and figures, room on the road.',
    trans: 'Comes with a Speedy car to race.',
    unimog: 'Rated from 24 months for the littlest driver.'
  };

  /* ---------- Setup ---------- */
  document.documentElement.classList.add(LIVE ? 'is-live' : 'is-preview');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const money = n => '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : Math.round(n).toString());
  const productImg = (k, w = 700) => LIVE ? 'https://rarely.co/cdn/shop/files/' + P[k].img + '&width=' + w : 'img/p-' + k + '.jpg';
  let ready = false, busy = false, ambiguous = sessionStorage.getItem('fagus-floor-level-ambiguous') === '1';
  Object.values(P).forEach(p => { p.available = false; });
  const avail = k => ready && P[k] && P[k].available === true;

  if (!LIVE) ['#bagbtn', '#bagbar', '#sheet-bag'].forEach(s => $(s).setAttribute('href', '#'));

  /* ---------- Rarely Young logo ---------- */
  // Tries the optimized copy in Shopify Files first, then the theme asset, then falls back to text.
  const LOGO_FILE = 'rarely-young-wordmark.webp';
  const LOGO_THEME = 'https://rarely.co/cdn/shop/t/22/assets/ry-home-20260910-wordmark.webp?v=88950057592656394311789057053';
  $$('img[data-logo]').forEach(img => {
    const tries = [window.FAGUS_FLOOR_ASSETS[LOGO_FILE]];
    let n = 0;
    img.addEventListener('error', () => {
      n++;
      if (n < tries.length) { img.src = tries[n]; return; }
      img.hidden = true;
      if (img.nextElementSibling) img.nextElementSibling.hidden = false;
    });
    img.src = tries[0];
  });
  // The header shows the logo once the hero's tag has scrolled away, so it never appears twice.
  const heroTag = $('.presents .tag');
  if ('IntersectionObserver' in window && heroTag) {
    new IntersectionObserver(es => $('#top').classList.toggle('brandon', !es[0].isIntersecting), { rootMargin: '-64px 0px 0px 0px' }).observe(heroTag);
  } else $('#top').classList.add('brandon');
  if (HOLIDAY_NOTE) { const h = $('#holiday'); h.textContent = HOLIDAY_NOTE; h.hidden = false; }

  /* ---------- Photos ---------- */
  const SIZES = { 'fagus-01-hero-wide.webp': '100vw', 'fagus-07-fleet.webp': '(max-width: 1280px) 100vw, 1220px', 'fagus-06-parts.webp': '(max-width: 860px) 100vw, 44vw' };
  $$('img[data-file]').forEach(img => {
    const file = img.dataset.file;
    const src = window.FAGUS_FLOOR_ASSETS[file];
    if (false) {
      img.sizes = SIZES[file] || '(max-width: 860px) 100vw, 52vw';
      img.srcset = [800, 1400, 2000, 2400].map(w => `${src}?width=${w} ${w}w`).join(', ');
    }
    img.addEventListener('error', () => {
      if (img.dataset.fallback && !img.dataset.fell) {
        img.dataset.fell = '1'; img.removeAttribute('srcset');
        img.src = productImg(img.dataset.fallback, 900);
        img.style.background = '#fff'; img.style.borderRadius = '20px';
      } else if (img.closest('.rider')) img.closest('.rider').hidden = true;
    });
    img.src = src;
  });
  $$('img[data-product]').forEach(i => { i.src = productImg(i.dataset.product, 200); i.loading = 'lazy'; });

  /* ---------- Product cards ---------- */
  function cardHTML(k, o = {}) {
    const p = P[k];
    const opener = `type="button" data-details="${k}" aria-haspopup="dialog" aria-controls="fg-product-dialog"`;
    return `<article class="card${o.wide ? ' wide' : ''}${avail(k) ? '' : ' sold'}" data-card="${k}">
      <button class="media" ${opener} aria-label="Details about the ${p.name}">
        <img src="${productImg(k)}" alt="" loading="lazy" decoding="async">
        ${p.badge ? `<span class="badge">${p.badge}</span>` : ''}<span class="badge sold-b">Restocking</span>
      </button>
      <div class="body">
        <div class="ttl"><h3><button class="product-title" ${opener}>${p.name}</button></h3><span class="price" data-price="${k}">${money(p.price)}</span></div>
        <p class="does">${o.why || p.does}</p>
        <ul class="specs">${p.specs.map(s => `<li>${s}</li>`).join('')}</ul>
        <div class="acts">
          <button class="add" type="button" ${!avail(k) || busy || ambiguous ? 'disabled' : ''} id="add-${k}${o.idSuffix || ''}" data-add="${k}">Add to bag</button>
          <a class="notify" href="#fagus-restock">Get a restock alert</a>
          <button class="details" ${opener}>Details<span class="vh"> about the ${p.name}</span></button>
        </div>
      </div>
    </article>`;
  }
  $$('[data-cards]').forEach(box => {
    box.innerHTML = box.dataset.cards.split(' ').map(k => cardHTML(k, { wide: box.hasAttribute('data-wide') })).join('');
  });

  function paintProducts() {
    $$('[data-card]').forEach(c => c.classList.toggle('sold', !avail(c.dataset.card)));
    $$('[data-price]').forEach(s => { s.textContent = money(P[s.dataset.price].price); });
    $$('[data-sum]').forEach(s => { s.textContent = money(s.dataset.sum.split(' ').reduce((t, k) => t + P[k].price, 0)); });
    const from = Math.min(...TRUCKS.filter(avail).map(k => P[k].price));
    $$('[data-from]').forEach(s => { s.textContent = Number.isFinite(from) ? money(from) : '—'; });
    $('#speedy-note').hidden = avail('speedy');
    $('.hero-tag').hidden = !avail('dumper');
  }
  paintProducts();

  /* ---------- Shared in-place product details ---------- */
  const detailDialog = document.createElement('div');
  detailDialog.id = 'fg-product-dialog';
  detailDialog.className = 'fg-product-dialog';
  detailDialog.hidden = true;
  detailDialog.setAttribute('role', 'dialog');
  detailDialog.setAttribute('aria-modal', 'true');
  detailDialog.setAttribute('aria-labelledby', 'fg-product-title');
  detailDialog.setAttribute('aria-describedby', 'fg-product-status');
  detailDialog.innerHTML = `<div class="fg-product-panel" tabindex="-1"><button id="fg-product-close" type="button" aria-label="Close product details">×</button><h2 id="fg-product-title"></h2><p id="fg-product-status" role="status"></p><div class="fg-product-gallery"></div><div id="fg-product-description"></div><div class="fg-product-actions"><strong id="fg-product-price"></strong><button class="add" id="fg-product-add" type="button" disabled>Add to bag</button><a id="fg-product-restock" href="#fagus-restock" hidden>Get a restock alert</a><button id="fg-product-retry" type="button" hidden>Retry details</button></div></div>`;
  document.body.appendChild(detailDialog);
  let detailKey = null, detailTrigger = null, detailOrigin = null, scrollStyles = null, inertNodes = [];
  function paintDetails() {
    if (!detailKey) return;
    const p = P[detailKey], data = p.details;
    $('#fg-product-title').textContent = data ? data.title : p.name;
    $('#fg-product-status').textContent = !ready ? 'Details or availability could not be checked. Retry to refresh.' : avail(detailKey) ? 'In stock' : 'Restocking';
    $('#fg-product-price').textContent = ready ? money(p.price) : 'Price awaiting verification';
    $('#fg-product-description').innerHTML = data ? data.description : '';
    const gallery = $('.fg-product-gallery', detailDialog);
    gallery.replaceChildren();
    (data ? data.images : []).forEach((src, i) => {
      const image = document.createElement('img'); image.src = src;
      image.alt = (data.title || p.name) + ' — photo ' + (i + 1); image.loading = 'lazy'; image.decoding = 'async'; gallery.appendChild(image);
    });
    $('#fg-product-add').dataset.add = detailKey;
    $('#fg-product-add').textContent = ready && !avail(detailKey) ? 'Restocking' : 'Add to bag';
    $('#fg-product-restock').hidden = !ready || avail(detailKey);
    $('#fg-product-retry').hidden = ready;
    lockButtons();
  }
  function closeDetails() {
    if (detailDialog.hidden) return;
    detailDialog.hidden = true; detailKey = null;
    document.body.style.overflow = scrollStyles.body;
    document.documentElement.style.overflow = scrollStyles.html;
    inertNodes.forEach(([node, wasInert]) => { node.inert = wasInert; }); inertNodes = [];
    const trigger = detailTrigger && detailTrigger.isConnected ? detailTrigger :
      detailOrigin && $(`[data-card="${detailOrigin.key}"] .${detailOrigin.kind}`, detailOrigin.container);
    if (trigger) trigger.focus({preventScroll:true});
  }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-details]');
    if (!trigger || !P[trigger.dataset.details]) return;
    detailKey = trigger.dataset.details; detailTrigger = trigger;
    detailOrigin = {key:detailKey, kind:trigger.classList[0], container:trigger.closest('#fresult') || document};
    hideSheet(); paintDetails();
    scrollStyles = {body:document.body.style.overflow, html:document.documentElement.style.overflow};
    document.body.style.overflow = 'hidden'; document.documentElement.style.overflow = 'hidden';
    inertNodes = [...document.body.children].filter(node => node !== detailDialog).map(node => [node, node.inert]);
    inertNodes.forEach(([node]) => { node.inert = true; });
    detailDialog.hidden = false; $('#fg-product-close').focus();
  });
  $('#fg-product-close').addEventListener('click', closeDetails);
  $('#fg-product-restock').addEventListener('click', () => { closeDetails(); const target=$('#fagus-restock'); if(target){target.setAttribute('tabindex','-1');target.focus();} });
  $('#fg-product-retry').addEventListener('click', syncLive);
  detailDialog.addEventListener('click', e => { if (e.target === detailDialog) closeDetails(); });
  document.addEventListener('keydown', e => {
    if (detailDialog.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); closeDetails(); }
    if (e.key === 'Tab') {
      const controls = $$('button:not(:disabled), a[href], [tabindex="0"]', detailDialog).filter(el => !el.hidden && !el.closest('[hidden]'));
      const first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && (document.activeElement === first || !detailDialog.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !detailDialog.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  }, true);
  document.addEventListener('focusin', e => { if (!detailDialog.hidden && !detailDialog.contains(e.target)) $('#fg-product-close').focus(); });

  /* ---------- Truck finder ---------- */
  const PICKS = {
    lift:    ['loader', 'dumper',  'The bucket really raises and lowers on wooden joints, and the whole loader steers. Two removable figures run the site.'],
    dump:    ['dumper', 'trailer', 'Steer it, load it, tip the bed. Add the trailer and it hauls two loads at once.'],
    rescue:  ['fire',   'loader',  'A three-section ladder that rotates, raises and reaches about 26 inches, with six firefighters on board.'],
    cars:    ['trans',  'jeep',    'The top deck folds down into a ramp, a knob on the cab steers, and a Speedy car comes with it.'],
    offroad: ['jeep',   'trailer', 'Steerable, 11 inches long, two figures riding along, and it takes the Dumper Trailer.'],
    race:    ['trans',  'jeep',    'The Speedy Car is restocking, but one rides along with every Car Transporter.']
  };
  const F = { age: '3', love: 'dump' };
  function renderFinder() {
    $$('[data-age]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.age === F.age)));
    $$('[data-love]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.love === F.love)));
    const young = F.age === 'u2' || F.age === '2';
    $('#q2').classList.toggle('dim', young);
    $('#q2note').hidden = !young;
    if (F.age === 'u2') { $('#fresult').innerHTML = '<p class="pick-k">Not suitable yet</p><p>None of these toys are rated for children under two. The Unimog starts at 24 months; the other listed age-rated toys start at three.</p>'; return; }
    let pick, alt, why;
    if (young) {
      pick = 'unimog'; alt = null;
      why = F.age === 'u2'
        ? 'Fagus starts at 24 months. The Unimog is the one rated from two, so it’s ready for their second birthday.'
        : 'The only one here rated from 24 months. It steers like the big trucks. The Dumper Trailer is rated 3+ and is not recommended for a two-year-old.';
    } else {
      [pick, alt, why] = PICKS[F.love];
      if (F.love === 'race' && avail('speedy')) { pick = 'speedy'; alt = 'trans'; why = 'Hand-sized, with rubber tires that roll beautifully across the floor.'; }
    }
    const both = alt && avail(alt) && avail(pick);
    $('#fresult').innerHTML = `<p class="pick-k">Start with the</p>${cardHTML(pick, { why, wide: true, idSuffix: '-pick' })}` +
      (both ? `<div class="pair"><span>Pairs well with</span><button class="pairbtn" type="button" id="add-pair" data-add="${alt}"><img src="${productImg(alt, 120)}" alt="">${P[alt].name} · ${money(P[alt].price)} <b>Add</b></button><button class="pairbtn" type="button" id="add-pair-both" data-add="${pick} ${alt}"><b>Add both · ${money(P[pick].price + P[alt].price)}</b></button></div>` : '');
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-age]');
    const l = e.target.closest('[data-love]');
    if (a) { F.age = a.dataset.age; renderFinder(); lockButtons(); }
    if (l) { F.love = l.dataset.love; renderFinder(); lockButtons(); }
  });
  renderFinder();

  /* ---------- Look closer ---------- */
  function lightCall(n) {
    $$('[data-hot]').forEach(h => h.classList.toggle('on', h.dataset.hot === n));
    $$('[data-call]').forEach(c => c.classList.toggle('on', c.dataset.call === n));
  }
  $$('[data-hot]').forEach(h => {
    h.addEventListener('mouseenter', () => lightCall(h.dataset.hot));
    h.addEventListener('focus', () => lightCall(h.dataset.hot));
    h.addEventListener('click', () => lightCall(h.dataset.hot));
  });
  $$('[data-call]').forEach(c => c.addEventListener('mouseenter', () => lightCall(c.dataset.call)));

  /* ---------- Do the math ---------- */
  const M = { kids: 1 };
  function fillMath() {
    const sel = $('#math-truck');
    const keep = sel.value || 'dumper';
    sel.innerHTML = TRUCKS.filter(avail).map(k => `<option value="${k}">${P[k].name} · ${money(P[k].price)}</option>`).join('');
    sel.value = avail(keep) ? keep : (sel.options[0] ? sel.options[0].value : '');
  }
  function renderMath() {
    const k = $('#math-truck').value;
    if (!P[k]) { $('#math-year').textContent = '—'; $('#math-week').textContent = 'Awaiting live prices'; return; }
    const years = +$('#math-years').value;
    $('#math-years-out').textContent = years + (years === 1 ? ' year' : ' years');
    $$('[data-kids]').forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.kids === M.kids)));
    const perYear = P[k].price / years / M.kids;
    const perWeek = perYear / 52;
    $('#math-year').textContent = perYear >= 10 ? '$' + Math.round(perYear) : money(Math.round(perYear * 100) / 100);
    $('#math-label').textContent = M.kids > 1 ? 'per kid, per year of play' : 'a year of play';
    $('#math-week').textContent = 'About ' + (perWeek < 1 ? Math.round(perWeek * 100) + '¢' : money(Math.round(perWeek * 100) / 100)) + ' a week';
  }
  fillMath();
  $('#math-truck').addEventListener('change', renderMath);
  $('#math-years').addEventListener('input', renderMath);
  document.addEventListener('click', e => { const b = e.target.closest('[data-kids]'); if (b) { M.kids = +b.dataset.kids; renderMath(); } });
  renderMath();

  /* ---------- Fleet builder ---------- */
  const BUILD = ['jeep', 'dumper', 'fire', 'trans', 'loader', 'trailer', 'unimog'];
  const picked = new Set(['jeep', 'dumper', 'fire', 'trans']);
  function renderTiles() {
    $('#tiles').innerHTML = BUILD.filter(avail).map(k => `<label class="tile" for="pick-${k}">
        <input type="checkbox" id="pick-${k}" data-pick="${k}"${picked.has(k) ? ' checked' : ''}>
        <span class="tick"><svg width="14" height="14" viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8" fill="none" stroke="#FFC83D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <img src="${productImg(k, 360)}" alt="" loading="lazy">
        <span class="tl"><b>${P[k].name}</b>${money(P[k].price)}</span>
      </label>`).join('');
  }
  function renderTotal() {
    const list = [...picked].filter(avail);
    const sum = list.reduce((t, k) => t + P[k].price, 0);
    $('#b-count').textContent = list.length + (list.length === 1 ? ' truck' : ' trucks');
    $('#b-sum').textContent = money(sum);
    const save = $('#b-save');
    if (MULTI_BUY && list.length >= MULTI_BUY.min) {
      save.hidden = false;
      save.textContent = `Save ${MULTI_BUY.percent}% at checkout, about ${money(Math.round(sum * MULTI_BUY.percent) / 100)}`;
    } else if (MULTI_BUY) {
      save.hidden = false;
      save.textContent = `Pick ${MULTI_BUY.min} or more to save ${MULTI_BUY.percent}% at checkout`;
    } else save.hidden = true;
    const btn = $('#add-fleet');
    btn.textContent = list.length ? `Add ${list.length === 1 ? 'it' : 'all ' + list.length} to bag` : 'Pick a truck to start';
    btn.dataset.add = list.join(' '); btn.disabled = busy || ambiguous || !ready || !list.length;
    $$('[data-preset]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.preset !== '' && b.dataset.preset.split(' ').sort().join() === [...picked].sort().join())));
  }
  document.addEventListener('change', e => {
    const c = e.target.closest('[data-pick]');
    if (c) { c.checked ? picked.add(c.dataset.pick) : picked.delete(c.dataset.pick); renderTotal(); }
  });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-preset]');
    if (!b) return;
    picked.clear();
    b.dataset.preset.split(' ').filter(Boolean).forEach(k => picked.add(k));
    $$('[data-pick]').forEach(c => { c.checked = picked.has(c.dataset.pick); });
    renderTotal();
  });
  renderTiles();
  renderTotal();

  /* ---------- Bag ---------- */
  const cart = { count: 0, total: 0, keys: new Set() };
  let toastTimer;
  function toast(msg) {
    const t = $('#toast');
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 3000);
  }
  function paintCart() {
    $('#bagn').textContent = cart.count;
    $('#bbc').textContent = cart.count + (cart.count === 1 ? ' item' : ' items');
    $('#bbt').textContent = money(cart.total);
    const ship = $('#bbship');
    if (FREE_SHIP_AT > 0 && cart.count) {
      ship.hidden = false;
      ship.textContent = cart.total >= FREE_SHIP_AT ? 'Free shipping' : money(FREE_SHIP_AT - cart.total) + ' to free shipping';
    } else ship.hidden = true;
    dockState();
  }
  async function refreshCart() {
    const r = await fetch('/cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
    if (!r.ok) throw new Error('Unable to verify bag');
    const c = await r.json();
    cart.count = c.item_count; cart.total = c.total_price / 100; cart.keys.clear();
    c.items.forEach(i => { const k = Object.keys(P).find(k => P[k].variant === i.variant_id); if(k) cart.keys.add(k); });
    paintCart(); return c;
  }
  async function variantFor(k) {
    if (P[k].variant) return P[k].variant;
    const j = await (await fetch('/products/' + P[k].handle + '.js', { headers: { Accept: 'application/json' } })).json();
    return (P[k].variant = (j.variants.find(x => x.available) || j.variants[0]).id);
  }
  function showSheet(list) {
    $('#sheet-items').textContent = list.map(k => P[k].name).join(' + ');
    const x = list.map(k => XSELL[k]).find(s => s && !(F.age === '2' && s !== 'unimog') && avail(s) && !cart.keys.has(s) && !list.includes(s));
    $('#sheet-xsell').innerHTML = x ? `<div class="xsell"><img src="${productImg(x, 160)}" alt=""><div><small>Make it a set</small><b>${P[x].name} · ${money(P[x].price)}</b><span>${XSELL_WHY[x] || ''}</span></div><button class="add" type="button" id="add-xsell" data-add="${x}">Add</button></div>` : '';
    $('#sheet').hidden = false;
    dockState();
  }
  function hideSheet() { $('#sheet').hidden = true; dockState(); }
  $('#sheet-close').addEventListener('click', hideSheet);
  $('#sheet-keep').addEventListener('click', hideSheet);
  addEventListener('keydown', e => { if (e.key === 'Escape') hideSheet(); });

  function lockButtons() {
    $$('[data-add]').forEach(b => { const keys=(b.dataset.add || '').split(' ').filter(Boolean); b.disabled = busy || ambiguous || !ready || !keys.length || !keys.every(avail); });
  }
  async function addToBag(keys, btn) {
    if (busy || ambiguous || !ready || !keys.length || !keys.every(avail)) return;
    busy=true; lockButtons(); let posted=false;
    try {
      const before=await refreshCart();
      await syncLive();
      if (!ready || !keys.every(avail)) throw new Error('Availability changed. Please review your selection.');
      const items=keys.map(k=>({id:P[k].variant,quantity:1}));
      posted=true; sessionStorage.setItem('fagus-floor-level-ambiguous','1');
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      if(!r.ok) { if(r.status===422) {posted=false; sessionStorage.removeItem('fagus-floor-level-ambiguous');} throw new Error('Could not confirm addition. Review your bag.'); }
      const after=await refreshCart();
      for(const item of items) {
        const qty=c=>c.items.filter(i=>i.variant_id===item.id).reduce((n,i)=>n+i.quantity,0);
        if(qty(after)!==qty(before)+1) throw new Error('Bag quantity could not be confirmed.');
      }
      sessionStorage.removeItem('fagus-floor-level-ambiguous'); posted=false;
      closeDetails(); showSheet(keys);
    } catch(e) { ambiguous=posted; $('#commerce-status').textContent=e.message; if (!detailDialog.hidden) $('#fg-product-status').textContent=e.message; toast(e.message); }
    finally { busy=false; lockButtons(); }
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-add]');
    if (b) { e.preventDefault(); if (b.dataset.add) addToBag(b.dataset.add.split(' '), b); return; }
    if (!LIVE && e.target.closest('#bagbtn, #bagbar, #sheet-bag')) {
      e.preventDefault();
      toast('This preview keeps a practice bag. On rarely.co this opens the cart.');
    }
  });

  /* ---------- Dock: bag bar, sheet and the phone nudge ---------- */
  let pastHero = false, finderVisible = false;
  function dockState() {
    const sheetOpen = !$('#sheet').hidden;
    $('#bagbar').hidden = cart.count < 1 || sheetOpen;
    $('#nudge').classList.toggle('show', !sheetOpen && cart.count < 1 && pastHero && !finderVisible);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(es => { pastHero = !es[0].isIntersecting; dockState(); }).observe($('.hero'));
    new IntersectionObserver(es => { finderVisible = es[0].isIntersecting; dockState(); }, { threshold: .15 }).observe($('#finder'));
  }

  async function syncLive() {
    ready=false; lockButtons(); $('#commerce-retry').hidden=true;
    try {
      const rows=await Promise.all(Object.keys(P).map(async k=>{
        const r=await fetch('/products/'+P[k].handle+'.js',{headers:{Accept:'application/json'},cache:'no-store',signal:AbortSignal.timeout(15000)});
        if(!r.ok) throw new Error('Product lookup failed');
        const p=await r.json(), v=p.variants.find(v=>v.id===P[k].variant);
        if(!v || !Number.isFinite(v.price)) throw new Error('Product mapping changed');
        return [k,v,p];
      }));
      rows.forEach(([k,v,p])=>Object.assign(P[k],{available:v.available===true,price:v.price/100,details:p})); ready=true;
      $('#commerce-status').textContent=ambiguous ? 'Review your bag before adding again: a previous addition was not confirmed.' : 'Prices and availability checked live.';
    } catch(e) {
      Object.values(P).forEach(p=>p.available=false);
      $('#commerce-status').textContent='Availability could not be checked. Purchases are paused. Please retry.';
      $('#commerce-retry').hidden=false;
    }
    paintProducts(); renderFinder(); fillMath(); renderMath(); renderTiles(); renderTotal(); lockButtons(); paintDetails();
  }
  $('#commerce-retry').addEventListener('click',syncLive);
  refreshCart().catch(()=>{});
  syncLive();

  /* ---------- Films ---------- */
  if (LIVE) {
    $$('[data-film]').forEach(tile => {
      const v = document.createElement('video');
      v.src = tile.dataset.film;
      v.muted = true; v.loop = true; v.playsInline = true; v.controls = true; v.preload = 'metadata';
      v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
      v.addEventListener('loadedmetadata', () => {
        if (v.videoWidth) tile.style.aspectRatio = v.videoWidth + ' / ' + v.videoHeight;
        tile.classList.add('ready');
      });
      tile.appendChild(v);
      if (!reduce && 'IntersectionObserver' in window) {
        new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }), { threshold: .4 }).observe(tile);
      }
    });
  }

  /* ---------- The road: each truck drives toward its stop as you scroll ---------- */
  const roads = $$('.road').map(el => ({ el, rider: $('.rider', el), sign: $('.sign', el), gl: 16, gr: 16, sw: 0 }));
  function measure() {
    const gr = parseFloat(getComputedStyle($('.wrap')).paddingRight) || 16;
    roads.forEach(R => {
      R.gl = parseFloat(getComputedStyle(R.sign).left) || 16;
      R.sw = R.sign.offsetWidth;
      R.gr = gr;
    });
  }
  let queued = false, first = true;
  function frame() {
    queued = false;
    $('#top').classList.toggle('scrolled', scrollY > 8);
    const vh = innerHeight;
    for (const R of roads) {
      const b = R.el.getBoundingClientRect();
      if (!first && (b.bottom < -80 || b.top > vh + 80)) continue;
      const p = reduce ? .5 : clamp((vh * .95 - b.top) / (vh * .62), 0, 1);
      const W = R.el.clientWidth, rw = R.rider.offsetWidth;
      const start = W - rw - R.gr;
      const end = W > 720 ? R.gl + R.sw + 24 : R.gl;
      const x = start + (end - start) * p;
      const d = start - x;
      const bob = reduce ? 0 : -Math.abs(Math.sin(d / 26)) * 2.2;
      const tilt = reduce ? 0 : Math.sin(d / 47) * .7;
      R.rider.style.transform = `translate3d(${x.toFixed(1)}px,${bob.toFixed(2)}px,0) rotate(${tilt.toFixed(2)}deg)`;
    }
    first = false;
  }
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(frame); } };
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', () => { measure(); queue(); });
  addEventListener('load', () => { measure(); queue(); });
  measure();
  frame();
})();
